export default {
  DEFAULT: 'default',
  MINIMUM: 'minimum',
  RECIPIENT_CC_ONE: 'recipient-one',
  RECIPIENT_CC_TWO: 'recipient-two',
  FILES_ONE: 'files-one',
  FILES_TWO: 'files-two'
}



// WEBPACK FOOTER //
// ./src/constants/inputHeight.js